var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Breadcrumb',{staticClass:"my",attrs:{"separator":" >> "}},_vm._l((_vm.BreadcrumbList),function(item,itemIndex){return _c('Breadcrumb-item',{key:itemIndex},[_vm._v(_vm._s(item))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }